import React from "react";
import * as RiIcons from 'react-icons/ri';
import * as AiIcons from 'react-icons/ai';

export const SideBarData = [
	{
		tytul: "Wstęp",
		ikonka: <AiIcons.AiFillInfoCircle/>,
		path: '/analiza/pojecia-wstepne',
		zamknieta: <RiIcons.RiArrowDownSFill/>,
		otwarta: <RiIcons.RiArrowUpSFill/>,
		suby:[
			{
				tytul: "Podstawy",
				path:'/analiza/pojecia-wstepne',
				ikonka: <AiIcons.AiFillHome/>,
				zamknieta: <RiIcons.RiArrowDownSFill/>,
				otwarta: <RiIcons.RiArrowUpSFill/>,
			},
			{
				tytul: "Logika",
				path:'/analiza/pojecia-wstepne/logika',
				ikonka: <AiIcons.AiFillHome/>,
				zamknieta: <RiIcons.RiArrowDownSFill/>,
				otwarta: <RiIcons.RiArrowUpSFill/>,
			},
			{
				tytul: "Kwantyfikatory",
				path:'/analiza/pojecia-wstepne/kwantyfikatory',
				ikonka: <AiIcons.AiFillHome/>,
				zamknieta: <RiIcons.RiArrowDownSFill/>,
				otwarta: <RiIcons.RiArrowUpSFill/>,
			},
			{
				tytul: "Relacje",
				path:'/analiza/pojecia-wstepne/relacje',
				ikonka: <AiIcons.AiFillHome/>,
				zamknieta: <RiIcons.RiArrowDownSFill/>,
				otwarta: <RiIcons.RiArrowUpSFill/>,
			},
			{
				tytul: "Nierówności",
				path:'/analiza/pojecia-wstepne/nierownosci-1-stopnia-1',
				ikonka: <AiIcons.AiFillHome/>,
				zamknieta: <RiIcons.RiArrowDownSFill/>,
				otwarta: <RiIcons.RiArrowUpSFill/>,
			},
			{
				tytul: "Dwumian Newtona",
				path:'/analiza/pojecia-wstepne/dwumian-Newtona',
				ikonka: <AiIcons.AiFillHome/>,
				zamknieta: <RiIcons.RiArrowDownSFill/>,
				otwarta: <RiIcons.RiArrowUpSFill/>,
			},
			{
				tytul: "Ciągi nieskończone",
				path:'/analiza/pojecia-wstepne/ciagi-nieskonczone',
				ikonka: <AiIcons.AiFillHome/>,
				zamknieta: <RiIcons.RiArrowDownSFill/>,
				otwarta: <RiIcons.RiArrowUpSFill/>,
			},
			{
				tytul: "Szeregi liczbowe",
				path:'/analiza/pojecia-wstepne/szeregi-liczbowe',
				ikonka: <AiIcons.AiFillHome/>,
				zamknieta: <RiIcons.RiArrowDownSFill/>,
				otwarta: <RiIcons.RiArrowUpSFill/>,
			},
		]
	},
	{
		tytul: "Podstawy",
		ikonka: <AiIcons.AiFillFire/>,
		path: '/analiza/srednio-zaawansowane',
		zamknieta: <RiIcons.RiArrowDownSFill/>,
		otwarta: <RiIcons.RiArrowUpSFill/>,
		suby:[
			{
				tytul: "Funkcja jednej zmiennej",
				path:'/analiza/funkcja-jednej-zmiennej',
				ikonka: <AiIcons.AiFillHome/>,
				zamknieta: <RiIcons.RiArrowDownSFill/>,
				otwarta: <RiIcons.RiArrowUpSFill/>,
			},
			{
				tytul: "Symetria punktów i osi",
				path:'/analiza/pojecia-wstepne/symetria-prosta',
				ikonka: <AiIcons.AiFillHome/>,
				zamknieta: <RiIcons.RiArrowDownSFill/>,
				otwarta: <RiIcons.RiArrowUpSFill/>,
			},
		]
	},
	{
		tytul: "Zaawansowane",
		ikonka: <AiIcons.AiFillBulb/>,
		path: '/analiza/zaawansowane',
		zamknieta: <RiIcons.RiArrowDownSFill/>,
		otwarta: <RiIcons.RiArrowUpSFill/>,
		suby:[
			{
				tytul: "Granice funkcji",
				path:'/analiza/granice-funkcji',
				ikonka: <AiIcons.AiFillHome/>,
				zamknieta: <RiIcons.RiArrowDownSFill/>,
				otwarta: <RiIcons.RiArrowUpSFill/>,
			},
			{
				tytul: "Pochodne",
				path:'/analiza/pochodne',
				ikonka: <AiIcons.AiFillHome/>,
				zamknieta: <RiIcons.RiArrowDownSFill/>,
				otwarta: <RiIcons.RiArrowUpSFill/>,
			},
			{
				tytul: "Liczby zespolone",
				path:'/analiza/liczby-zespolone',
				ikonka: <AiIcons.AiFillHome/>,
				zamknieta: <RiIcons.RiArrowDownSFill/>,
				otwarta: <RiIcons.RiArrowUpSFill/>,
			},
			{
				tytul: "Całki",
				path:'/analiza/calki',
				ikonka: <AiIcons.AiFillHome/>,
				zamknieta: <RiIcons.RiArrowDownSFill/>,
				otwarta: <RiIcons.RiArrowUpSFill/>,
			},
		]
	},
];
